'use client';
import { useState, useRef, useCallback, useEffect } from 'react';
import { useStateMachine } from '../useStateMachine/useStateMachine.js';
import { useInterval } from '../useInterval/useInterval.js';

function _extends() {
    _extends = Object.assign || function(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source){
                if (Object.prototype.hasOwnProperty.call(source, key)) {
                    target[key] = source[key];
                }
            }
        }
        return target;
    };
    return _extends.apply(this, arguments);
}
var getTime = function(time, interval) {
    var roundedTime = Math.round(time / interval) * interval;
    var seconds = Math.floor(roundedTime / 1000 % 60);
    var minutes = Math.floor(roundedTime / 1000 % (60 * 60) / 60);
    var hours = Math.floor(roundedTime / 1000 % (60 * 60 * 24) / (60 * 60));
    var days = Math.floor(roundedTime / 1000 / (60 * 60 * 24));
    return {
        time: roundedTime,
        seconds: seconds,
        minutes: minutes,
        hours: hours,
        days: days
    };
};
var useTimer = function(param) {
    var time = param.time, _param_autoStart = param.autoStart, autoStart = _param_autoStart === void 0 ? true : _param_autoStart, _param_interval = param.interval, interval = _param_interval === void 0 ? 1000 : _param_interval, _param_type = param.type, type = _param_type === void 0 ? "decremental" : _param_type, onUpdate = param.onUpdate, onEnd = param.onEnd;
    var _useState = useState(type === "decremental" ? time : 0), currentTime = _useState[0], setCurrentTime = _useState[1];
    var prevTime = useRef(Date.now());
    var _useStateMachine = useStateMachine("stopped", {
        stopped: {
            START: "running",
            PAUSE: "stopped"
        },
        running: {
            STOP: "stopped",
            PAUSE: "paused"
        },
        paused: {
            START: "running",
            STOP: "stopped"
        }
    }), state = _useStateMachine[0], send = _useStateMachine[1];
    var start = useCallback(function() {
        send("START");
        prevTime.current = Date.now();
    }, []);
    var pause = useCallback(function() {
        send("PAUSE");
    }, []);
    var reset = useCallback(function(newTime, newAutoStart) {
        if (newTime === void 0) newTime = time;
        if (newAutoStart === void 0) newAutoStart = autoStart;
        setCurrentTime(type === "decremental" ? newTime : 0);
        send(newAutoStart ? "START" : "STOP");
        prevTime.current = Date.now();
    }, [
        time,
        autoStart,
        type,
        prevTime.current
    ]);
    useEffect(function() {
        if (autoStart) {
            start();
        }
    }, [
        autoStart
    ]);
    useInterval(function() {
        var elapsed = Date.now() - prevTime.current;
        prevTime.current = Date.now();
        setCurrentTime(function(prev) {
            return type === "decremental" ? prev - elapsed : prev + elapsed;
        });
        onUpdate == null ? void 0 : onUpdate(currentTime);
        if (type === "decremental" ? currentTime - elapsed <= 0 : currentTime + elapsed >= time) {
            send("STOP");
            onEnd == null ? void 0 : onEnd();
        }
    }, state === "running" ? interval : null);
    return _extends({
        start: start,
        pause: pause,
        reset: reset,
        state: state
    }, getTime(currentTime, interval));
};

export { useTimer };
